// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"6a24b6ba","396":"2e7d5e80","455":"6fec6d9e"}[chunkId] + ".chunk.js";
};